import storeFactory from '@/helpers/storeFactory'

export default storeFactory({
  model: {
    event_uuid: null,
    from: null,
    to: null,
    via: null,
    type: null,
    train_number: null,
    status: null
  },
  getters: {
    newItemsCount(state, _, rootState) {
      const trafficMessageModel = rootState.trafficMessage.model
      const replacements = trafficMessageModel.replacements
      const checkedItems = Object.values(state.data).filter(
        x => x.checked && !x.deleted
      )
      return checkedItems.filter(x => !replacements.includes(x.uuid)).length
    },

    missingItemsCount(state, _, rootState) {
      const trafficMessageModel = rootState.trafficMessage.model
      const replacements = trafficMessageModel.replacements
      const missingItems =
        replacements?.filter(
          uuid => state.data[uuid] && !state.data[uuid].checked
        ) || []
      return missingItems.length
    },

    diffItemsCount(state, getters) {
      return getters['newItemsCount'] + getters['missingItemsCount']
    }
  }
})
